import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { VetrinaMesePageComponent } from './vetrina-mese-page.component';
import {SharedModule} from '../../shared/shared.module';
import {RouterModule, Routes} from '@angular/router';

const routes: Routes = [
  { path: '', component: VetrinaMesePageComponent },
];

@NgModule({
  declarations: [VetrinaMesePageComponent],
  imports: [
    CommonModule,
    SharedModule,
    RouterModule.forChild(routes),
  ],
  exports: [VetrinaMesePageComponent]
})
export class VetrinaMesePageModule { }
